class CC_Cart {
    constructor(cartEl, options = {}){
        this.options = Object.assign(
            {},
            {   
                minicart: true,
                config: "",
                preview_gift_simple: true, 
                catalogPrice : [], 
                trad: {}
            }, 
            options
        );    
 

        //Variables
        this.lineCount = 0; 
        this.cartEl = cartEl;  
        this.contentItems = this.cartEl.querySelector(".content-list-items");
        this.contentOffersTimeline = this.cartEl.querySelector(".content-offers-timeline");
        this.contentTotal = this.cartEl.querySelector(".content-total");
        this.btnCo = this.cartEl.querySelector("#btn-checkout"); 
        this.cart = JSON.parse(document.getElementById('cart-json').textContent); 
        this.cartCount = document.querySelector("#cart-count");
        this.header = document.querySelector("#header");
        this.body = document.querySelector("body");

        this.giftMaxPrice = 0;
        this.palliersGifts = [];  

        let selectVariantsMin = document.querySelectorAll(".content-btn-select .btn");
        selectVariantsMin.forEach(select => { 
            select.addEventListener("click", (e) => {
                select.closest(".product-min.variants-switch").classList.add("open");
            });
        });

        let variantsMin = document.querySelectorAll(".product-min .content-variants .variant");
        variantsMin.forEach(variant => { 
            variant.addEventListener("click", (e) => { 
                if(variant.closest(".product-min.variants-switch") != null){
                    variant.closest(".product-min.variants-switch").classList.add("open");
                } 
                let getId = variant.getAttribute("data-id");
                let getName = variant.getAttribute("data-name");
                let getImage = variant.getAttribute("data-image");

                variant.closest(".product-min").querySelector(".current-color .color").style.background = variant.querySelector(".color").style.background;
                variant.closest(".content-variants").querySelector(".variant.active").classList.remove("active");
                variant.closest(".content-infos-prd").querySelector(".title-variant").innerHTML = getName;
                variant.closest(".product-min").querySelector(".content-img-prd .preview-variant").classList.add("loading");
                variant.closest(".product-min").querySelector(".content-img-prd .preview-variant img").src = getImage;
                variant.closest(".product-min").querySelector(".content-img-prd .preview-variant img").addEventListener('load', () => {
                    variant.closest(".product-min").querySelector(".content-img-prd .preview-variant").classList.remove("loading");
                }); 
                variant.classList.add("active");
                variant.closest(".product-min").querySelector(".add-to-cart").setAttribute("data-vid", getId);
            }); 
        });  

        var addToCart = document.querySelectorAll(".add-to-cart");
        addToCart.forEach(btn => {
            if(!btn.classList.contains("array")){
                btn.addEventListener("click", () => {
                    let props = "";
                    if(typeof btn.getAttribute("data-props") != "undefined"){
                        props = JSON.parse(btn.getAttribute("data-props"));
                    }
                    var vid = btn.getAttribute("data-vid");
                    this.addLoading(btn);
                    this.addItem(vid, 1, props, btn);  
                });
            }
        });  

        //INIT
        this.buildCart(this.cart); 
        if(this.options.config.cart_giftmessage_state){
            this.countGiftMessage(this.giftNoteText.value, this.giftNoteTextMax); 
        } 
        this.buildUpsell(this.options.config.title_upsell, this.options.config.upsell_collection);

        this.btnCo.addEventListener("click", (e)=> {
            e.preventDefault(); 
            this.goToCkeckout(e);
        });

        document.querySelectorAll(".reorder").forEach(btn => {
            btn.addEventListener("click", () => { 
                let ids = btn.getAttribute("data-ids").split(",");
                this.addItemArray(ids, "", btn);
            });
        })
 
    }  

    async goToCkeckout(e){
        const cart = await this.getCart(); 

        var url = e.target.closest("#btn-checkout").getAttribute("href");
        var total = Number(e.target.closest("#btn-checkout").querySelector(".total").innerHTML.slice(0, -1));
        var cb = () => {
            window.location.href = url;
        }
        
        let items_gtm = [];
        let value_gtm = 0; 

        for(const item of cart.items){  
            let discount = 0; 
            if(catalog[item.variant_id].data_compare_at_price != "" && catalog[item.variant_id].data_compare_at_price != "0"){
                if(parseInt(catalog[item.variant_id].data_price) < parseInt(catalog[item.variant_id].data_compare_at_price)){
                    discount = (parseInt(catalog[item.variant_id].data_compare_at_price) / 100) - (parseInt(catalog[item.variant_id].data_price) / 100);
                }
            }
            value_gtm += parseInt(catalog[item.variant_id].data_price) / 100;
            items_gtm.push({
                item_id: catalog[item.variant_id].id,
                group_id: catalog[item.variant_id].group_id,
                item_name: catalog[item.variant_id].name,
                discount: discount, 
                item_brand: catalog[item.variant_id].brand,
                item_category: catalog[item.variant_id].category, 
                price: parseInt(catalog[item.variant_id].data_price) / 100,
                quantity: 1
            });
        }  
        track.push({
            "event" : "begin_checkout",  
            value: value_gtm,
            items: items_gtm
        }, cb);  
    } 

    async checkGiftCard(item){
        if(item.product_type == "Cartes-cadeaux"){
            return true;
        }else{
            return false;
        }
    } 

    buildEventCartAfterDOM(btnAdd){ 
        btnAdd.addEventListener("click", () => {
            var vid = btnAdd.getAttribute("data-vid");
            this.addLoading(btnAdd); 
            //this.addItem(vid, 1, "", btnAdd, false, ""); 
            this.addItem(vid, 1, "", btnAdd, true);
        }); 
    }  
      
    countGiftMessage(value, max){
        var count = value.length; 
        var percent = ((parseInt(count) * 100) / max).toFixed(0);
        this.giftNote.querySelector(".progress-bar-count-car .bar").style.width = percent + "%";
        this.giftNote.querySelector(".count-car .count").innerHTML = count;
    }

    async majCountCart(number){
        if(this.cartCount != null){
            this.cartCount.innerHTML = number;
        }
    }

    async majPriceCart(cart){
        //this.cartCount.innerHTML = number; 

        var oldprice = 0;

        cart.items.forEach(item => {  
            if(typeof catalog[item.variant_id] != "undefined"){
                if(parseInt(catalog[item.variant_id].data_compare_at_price) > parseInt(catalog[item.variant_id].data_price)){
                    oldprice += parseInt(catalog[item.variant_id].data_compare_at_price) * item.quantity;
                }else{
                    oldprice += parseInt(catalog[item.variant_id].data_price) * item.quantity;
                } 
            }
        }); 

        if(oldprice > cart.total_price){
            this.btnCo.querySelector(".oldtotal").innerHTML = this.formatPrice(oldprice);
        }else{
            this.btnCo.querySelector(".oldtotal").innerHTML = "";
        }
        this.btnCo.querySelector(".total").innerHTML = this.formatPrice(cart.total_price);
    }

    addLoading(element){
      element.classList.add("loading");
    }

    removeLoading(element){ 
      element.classList.remove("loading");
    }

    formatPriceOffer(price, currency){
        switch(currency){
            case "EUR" : var devise = "€"; break;
            default : var devise = "€";  
        }
        return (price).toFixed(2)+ devise;
    }

    formatPrice(price, currency){
        switch(currency){
            case "EUR" : var devise = "€"; break;
            default : var devise = "€";  
        }
        return (parseInt(price) / 100).toFixed(2) + devise;
    }

    updateItemFront(cart, item, line, callback, majCart){  
        var itemTarget = this.contentItems.querySelector(".content-item[data-line='"+ line +"']");
        if(itemTarget.querySelector(".content-current") != null){
        itemTarget.querySelector(".content-current").innerHTML = item.quantity;
        }
        if(item.line_price == 0){
            itemTarget.querySelector(".content-price .price").innerHTML = "Offert";
        }else{
            itemTarget.querySelector(".content-price .price").innerHTML = this.formatPrice(item.line_price);
        } 
        itemTarget.setAttribute("data-qty", item.quantity); 
        itemTarget.setAttribute("data-price", item.final_line_price); 
        if(callback != "" && typeof callback == "function"){
            callback();
        } 
        if(majCart){
            this.majCart(cart);
        } 
    }

    removeItemFront(cart, item, line, callback, majCart){
        var itemTarget = this.contentItems.querySelector(".content-item[data-line='"+ line +"']");
        setTimeout(()=>{
            itemTarget.remove(); 
            if(majCart){
                this.majCart(cart);
            }
        }, 600);
        if(callback != "" && typeof callback == "function"){
            callback();
        }
        itemTarget.classList.add("remove");
    }

    async resetLine(cart){
        cart.items.forEach((item, line)  => {
            let vid = item.variant_id;
            this.contentItems.querySelector(`.content-item[data-vid="${vid}"]`).setAttribute("data-line", line);
        }); 
    }

    buildUpsell(title, upsell_collection){ 
        let contentUpsell = this.createElementWithClass("div", "content-upsell");  
        if(this.options.config.state_infos_promo_mobile){
            //contentUpsell.classList.add("hide-mob");
        }
        let upsell = this.createElementWithClass("div", "upsell");
        let contentPrds = this.createElementWithClass("div", "content-upsell-prds");

        let contentTitleUpsell = this.createElementWithClass("div", "content-title");
        let titleUpsell = this.createElementWithClass("div", "title-upsell");
        titleUpsell.textContent = title;
        contentTitleUpsell.append(titleUpsell);
        contentUpsell.append(contentTitleUpsell);


        //Arrow 
        let leftUpsell = this.createElementWithClass("div", "left-upsell");
        let rightUpsell = this.createElementWithClass("div", "right-upsell");

        upsell.append(leftUpsell);
        upsell.append(rightUpsell);

        upsell.append(contentPrds);

        upsell_collection.forEach(prd => {
            let contentPrdUpsell = this.createElementWithClass("div", "content-prd-upsell"); 
            let prdUpsell = this.createElementWithClass("div", "prd-upsell"); 
            let contentImg = this.createElementWithClass("div", "content-img");
            contentImg.style.background = "#ece8e6";
            let img = this.createElementWithClass("img", "img");
            img.src = prd.img;
            img.setAttribute("alt", prd.name);
            contentImg.append(img);
            let title = this.createElementWithClass("div", "title");
            title.textContent = prd.name;
            let price = this.createElementWithClass("div", "price");
            price.innerHTML = prd.price;
            let cta = this.createElementWithClass("button", "add-to-cart");
            let label = this.createElementWithClass("div", "label");
            cta.setAttribute("data-id", prd.id);
            label.textContent = "Ajouter";
            cta.append(price);
            cta.append(label);

            let contentLoader = this.createElementWithClass("div", "content-loader");
            let loader = this.createElementWithClass("div", "loader");
            let loaderMid = this.createElementWithClass("div", "mid"); 

            loader.append(loaderMid);
            contentLoader.append(loader);

            cta.append(contentLoader);

            let contentInfos = this.createElementWithClass("div", "content-infos");

            contentInfos.append(title); 
            contentInfos.append(cta);

            prdUpsell.append(contentImg);
            prdUpsell.append(contentInfos); 

            contentPrdUpsell.append(prdUpsell);

            contentPrds.append(contentPrdUpsell);

            cta.addEventListener("click", () => { 
                this.addLoading(cta);
                this.addItem(prd.id, 1, "", cta, false);
            });

        });

        contentUpsell.append(upsell);

        document.querySelector("#cart-upsell").append(contentUpsell);
        this.eventSlideUpsell();
    }

    eventSlideUpsell(){
        let currentSlideUpsell = 0;
        let nbUpseelPrd = document.querySelectorAll("#cart-upsell .content-prd-upsell").length;
        document.querySelector("#cart-upsell .left-upsell").addEventListener("click", (e) => {
            currentSlideUpsell--;
            if(currentSlideUpsell < 0){
                currentSlideUpsell = nbUpseelPrd - 1;
            } 
            let translateX = -(currentSlideUpsell * 100); 
            document.querySelector("#cart-upsell .content-upsell-prds").style.transform = 'translateX(' + translateX + '%) translate3d(0,0,0) translateZ(0)'; 
            document.querySelector("#cart-upsell .content-upsell-prds").style.WebkitTransform = 'translateX(' + translateX + '%) translate3d(0,0,0) translateZ(0)';  
        });
        document.querySelector("#cart-upsell .right-upsell").addEventListener("click", (e) => {
            currentSlideUpsell++;
            if(currentSlideUpsell > nbUpseelPrd -1){
                currentSlideUpsell = 0;
            } 
            let translateX = -(currentSlideUpsell * 100); 
            document.querySelector("#cart-upsell .content-upsell-prds").style.transform = 'translateX(' + translateX + '%) translate3d(0,0,0) translateZ(0)'; 
            document.querySelector("#cart-upsell .content-upsell-prds").style.WebkitTransform = 'translateX(' + translateX + '%) translate3d(0,0,0) translateZ(0)';  
        });
    }
    

    buildCompensateGift(total, cart){  
        var contentProgressGift = this.createElementWithClass("div", "content-progress-gift");  
        var progressGift = this.createElementWithClass("div", "progress-gift");  
        var progressBar = this.createElementWithClass("div", "progress-bar");  
         

        //Free shipping
        var svgFreeShipping = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 98.5 65.6" style="enable-background:new 0 0 98.5 65.6;" xml:space="preserve">
            <g>
                <path d="M98.2,35.7l-8.3-14.7c-0.3-0.5-0.8-0.9-1.4-0.9h-15V3.5C73.5,2.2,73,0,69.3,0H23.8c-3.3,0-5.3,1.3-5.3,3.5V7
                    c0,0.8,0.7,1.5,1.5,1.5c0.8,0,1.5-0.7,1.5-1.5l0-3.5C21.6,3.3,22.4,3,23.8,3h45.5c1,0,1.2,0.2,1.2,0.2c0,0,0,0.1,0,0.3V50
                    c0,0.2,0,0.3,0.1,0.5c-0.5,0.8-0.8,1.6-1.1,2.5c0,0,0,0-0.1,0H49.9c-1.2-4.2-5-7.3-9.6-7.3c-4.6,0-8.4,3.1-9.6,7.3h-6.9
                    c-0.9,0-2.3-1.4-2.3-2V38c0-0.8-0.7-1.5-1.5-1.5c-0.8,0-1.5,0.7-1.5,1.5v13c0,2.6,3,5,5.3,5h6.6c0.2,5.3,4.6,9.5,9.9,9.5
                    c5.3,0,9.7-4.2,9.9-9.5h18.9c0.2,5.3,4.6,9.6,9.9,9.6c5.4,0,9.7-4.3,9.9-9.6c0.1,0,0.1,0,0.2,0c7.5,0,9.2-4.9,9.2-5.1
                    c0-0.1,0.2-0.3,0.2-0.4v-14C98.5,36.1,98.3,35.9,98.2,35.7z M40.3,62.5c-3.8,0-6.9-3.1-6.9-6.9c0-3.8,3.1-7.1,6.9-6.9
                    c7.2,0.3,6.9,6.8,6.9,6.9C47.2,59.4,44.1,62.5,40.3,62.5z M79,62.6c-3.8,0-6.9-3.1-6.9-6.9c0-3.8,3.1-6.9,6.9-6.9
                    c3.8,0,6.9,3.1,6.9,6.9C86,59.5,82.9,62.6,79,62.6z M95.5,50.1c-1,0.7-1.9,3-6.8,2.8c-1.2-4.2-5.1-7.2-9.6-7.2c-2,0-4,0.6-5.6,1.7
                    V23h14.1l7.9,13.8V50.1z"/>
                <path d="M27,13.5c0-0.8-0.7-1.5-1.5-1.5h-24C0.7,12,0,12.7,0,13.5S0.7,15,1.5,15h24C26.3,15,27,14.3,27,13.5z"/>
                <path d="M27,22.5c0-0.8-0.7-1.5-1.5-1.5h-20C4.7,21,4,21.7,4,22.5S4.7,24,5.5,24h20C26.3,24,27,23.3,27,22.5z"/>
                <path d="M27,31.5c0-0.8-0.7-1.5-1.5-1.5h-15C9.7,30,9,30.7,9,31.5S9.7,33,10.5,33h15C26.3,33,27,32.3,27,31.5z"/>
            </g>
        </svg>`;
 
        //Gift
        var svgGift = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 98.1 87.1" style="enable-background:new 0 0 98.1 87.1;" xml:space="preserve">
            <g>
                <path d="M96.5,22.1h-17c2.9-3,4-6.7,4-9.5c0-5.3-5.3-12-12.2-12.4c-7.6-0.5-12.5,6.3-12.7,6.6l-9.4,14L39.8,6.6
                    C39.6,6.3,34.6-0.5,27,0c-6.9,0.5-12.2,7.2-12.2,12.5c0,2.8,1.1,6.5,4,9.5H1.6c-0.8,0-1.5,0.3-1.5,1.1v16.4c0,0.8,0.7,1.4,1.5,1.4
                    h4.5v44.1c0,0.8,0.7,1.9,1.5,1.9h33.6H57h34c0.8,0,1-1,1-1.9V41.1h4.4c0.8,0,1.6-0.6,1.6-1.4V23.2C98.1,22.4,97.3,22.1,96.5,22.1z
                    M61,8.6c0-0.1,4.2-5.8,10.1-5.5c5.4,0.4,9.4,6,9.4,9.5c0,2.8-1.5,6.5-5.8,9.5H57h-5L61,8.6z M55.1,38.1h-12v-13h6.2c0,0,0,0,0,0
                    h5.8V38.1z M17.9,12.5c0-3.5,3.9-9.1,9.4-9.4c5.9-0.4,10,5.4,10,5.5l8.9,13.5h-5H23.6C19.4,19.1,17.9,15.4,17.9,12.5z M3.1,25.1h37
                    v13H7.5H3.1V25.1z M9.1,41.1h31v43h-31V41.1z M43.1,84.1v-43h12v43H43.1z M89.1,84.1h-31v-43h31V84.1z M95.1,38.1h-4h-33v-13h37
                    V38.1z"/>
            </g>
        </svg>`;


        if(this.options.config.cart_free_shipping){
            var message = this.options.config.cart_free_shipping_message.replace("[PRICE]", `<span class="cal">${this.options.config.cart_free_shipping_min_price}</span>€`);
            var pallier = {
                "message" : message,
                "minPrice" : this.options.config.cart_free_shipping_min_price,
                "success" : this.options.config.cart_free_shipping_message_success,
                "icone" : this.options.config.cart_free_shipping_icon,
                "iconeSvg" : svgFreeShipping
            }
            this.palliersGifts.push(pallier);
            if(this.options.config.cart_free_shipping_min_price > this.giftMaxPrice){
                this.giftMaxPrice = this.options.config.cart_free_shipping_min_price;
            }
        }  

        if(this.options.config.cart_gift_state){
            var message = this.options.config.cart_gift_message.replace("[PRICE]", `<span class="cal">${this.options.config.cart_gift_min_price}</span>€`);
            var messageSucces = this.options.config.cart_gift_message_success.replace("[name]", `<strong class="name-prd">${this.options.config.cart_gift_product_name}</strong>`);
            var pallier = {
                "message" : message,
                "minPrice" : this.options.config.cart_gift_min_price,
                "nameproduct" : this.options.config.cart_gift_product_name,
                "imgProduct" : this.options.config.cart_gift_product_image,
                "success" : messageSucces,
                "icone" : this.options.config.cart_gift_icon,
                "iconeSvg" : svgGift
            }
            this.palliersGifts.push(pallier);
            if(this.options.config.cart_gift_min_price > this.giftMaxPrice){
                this.giftMaxPrice = this.options.config.cart_gift_min_price;
            } 
        } 

        if(this.options.config.cart_gift2_state){
            var message = this.options.config.cart_gift2_message.replace("[PRICE]", `<span class="cal">${this.options.config.cart_gift2_min_price}</span>€`);
            var messageSucces = this.options.config.cart_gift2_message_success.replace("[name]", `<strong class="name-prd">${this.options.config.cart_gift2_product_name}</strong>`);
            var pallier = {
                "message" : message,
                "minPrice" : this.options.config.cart_gift2_min_price,
                "nameproduct" : this.options.config.cart_gift2_product_name,
                "imgProduct" : this.options.config.cart_gift2_product_image,
                "success" : messageSucces,
                "icone" : this.options.config.cart_gift2_icon,
                "iconeSvg" : svgGift
            }
            this.palliersGifts.push(pallier);
            if(this.options.config.cart_gift2_min_price > this.giftMaxPrice){
                this.giftMaxPrice = this.options.config.cart_gift2_min_price;
            }
        } 

        if(this.options.config.cart_gift3_state){
            var message = this.options.config.cart_gift3_message.replace("[PRICE]", `<span class="cal">${this.options.config.cart_gift3_min_price}</span>€`);
            var messageSucces = this.options.config.cart_gift3_message_success.replace("[name]", `<strong class="name-prd">${this.options.config.cart_gift3_product_name}</strong>`);
            var pallier = {
                "message" : message,
                "minPrice" : this.options.config.cart_gift3_min_price,
                "nameproduct" : this.options.config.cart_gift3_product_name,
                "imgProduct" : this.options.config.cart_gift3_product_image,
                "success" : messageSucces,
                "icone" : this.options.config.cart_gift3_icon,
                "iconeSvg" : svgGift
            }
            this.palliersGifts.push(pallier);
            if(this.options.config.cart_gift3_min_price > this.giftMaxPrice){
                this.giftMaxPrice = this.options.config.cart_gift3_min_price;
            }
        } 

        var contentInfoPalliers = this.createElementWithClass("div", "content-info-palliers"); 
 
        this.palliersGifts.forEach((pallier, index) => {

            //Cursors
            var cursor = this.createElementWithClass("div", "cursor"); 
            cursor.setAttribute("data-price", pallier.minPrice);
            var contentPriceCursor = this.createElementWithClass("div", "content-price-cursor"); 
            contentPriceCursor.innerHTML = index+1;
 
            if(typeof this.palliersGifts[index+1] != "undefined" && this.palliersGifts[index+1].minPrice < pallier.minPrice + 10){
                cursor.classList.add("bottom");
            }
            var calLeftPosCursor = (pallier.minPrice * 100) / this.giftMaxPrice;
            cursor.style.left = calLeftPosCursor + "%";  
            cursor.appendChild(contentPriceCursor);
            progressGift.appendChild(cursor);  

            //Infos
            var infoPallier = this.createElementWithClass("div", "info-pallier"); 
            var iPallier = this.createElementWithClass("div", "pallier"); 
            var iconeInfoPallier = this.createElementWithClass("div", "icone"); 
            iconeInfoPallier.innerHTML = pallier.iconeSvg;
            var numberRef = this.createElementWithClass("div", "ref");
            numberRef.textContent = index+1;
            iconeInfoPallier.append(numberRef);
            var info = this.createElementWithClass("div", "info");
            info.setAttribute("data-init", pallier.message);
            info.setAttribute("data-success", pallier.success);
            info.setAttribute("data-price", pallier.minPrice);

            if(typeof pallier.imgProduct != "undefined" && pallier.imgProduct != "" || typeof pallier.nameproduct != "undefined" && pallier.nameproduct != ""){
                var contentProduct = this.createElementWithClass("div", "gift-product"); 
            } 

            if(!this.options.preview_gift_simple){
                if(typeof pallier.imgProduct != "undefined" && pallier.imgProduct != ""){
                    var contentImageProduct = this.createElementWithClass("div", "gift-image");
                    var imageP = this.createElementWithClass("img", "image");
                    imageP.setAttribute("alt", "palier cadeau");
                    imageP.src = pallier.imgProduct;
                    contentImageProduct.append(imageP);
                    contentProduct.appendChild(contentImageProduct); 
                } 
                if(typeof pallier.nameproduct != "undefined" && pallier.nameproduct != ""){ 
                    var contentNameProduct = this.createElementWithClass("div", "gift-name"); 
                    var nameProduct = this.createElementWithClass("div", "name");
                    nameProduct.innerHTML = pallier.nameproduct;
                    contentNameProduct.append(nameProduct);
                    contentProduct.appendChild(contentNameProduct);  
                }
            }

            info.innerHTML = pallier.message;
            iPallier.appendChild(iconeInfoPallier);
            iPallier.appendChild(info);
            infoPallier.appendChild(iPallier);
            if(!this.options.preview_gift_simple){
                if((typeof pallier.imgProduct != "undefined" && pallier.imgProduct != "") || (typeof pallier.nameproduct != "undefined" && pallier.nameproduct != "")){
                    infoPallier.appendChild(contentProduct);
                } 
            }
            contentInfoPalliers.appendChild(infoPallier);

        });

        contentProgressGift.appendChild(progressBar);
        contentProgressGift.appendChild(progressGift); 

        this.contentOffersTimeline.appendChild(contentProgressGift);
        this.contentOffersTimeline.appendChild(contentInfoPalliers); 
        this.majProgressbarShipping(total, this.palliersGifts, cart);
    }

    async majProgressbarShipping(total, palliers, cart){ 
        if((total/100) >= this.giftMaxPrice){
            this.contentOffersTimeline.querySelector(".progress-bar").style.width = "100%";
        }else{
            this.contentOffersTimeline.querySelector(".progress-bar").style.width  = total / this.giftMaxPrice + "%";
        }
        this.contentOffersTimeline.querySelectorAll(".cursor").forEach(cursor => {
            var price = parseInt(cursor.getAttribute("data-price"));
            if(price <= (total/100)){
                cursor.classList.add("active");
            }else{
                cursor.classList.remove("active");
            }
        }); 
        this.contentOffersTimeline.querySelectorAll(".info-pallier .info").forEach(info => {
          var price = parseInt(info.getAttribute("data-price"));
          var init = info.getAttribute("data-init");
          var success = info.getAttribute("data-success");
          if(price <= (total/100)){
            info.innerHTML = success;
            info.closest(".info-pallier").classList.add("active");
          }else{ 
            info.innerHTML = init;
            var rest = price - (total/100);
            info.querySelector(".cal").innerHTML = rest.toFixed(2);
            info.closest(".info-pallier").classList.remove("active");
          }
        }); 

        if(!this.options.config.cart_gift_app_state && this.options.config.cart_gift_state){ 
            let giftInCart = false;
            let line = 0;
            let lineI = 0;
            let lineQty = 1; 
            let vid = this.options.config.cart_gift_product_vid; 
            for(const item of cart.items){
                if(vid == item.variant_id){
                    giftInCart = true;
                    line = lineI;
                    lineQty = item.quantity;
                } 
                lineI++;
            } 
            if(!giftInCart){
                if(cart.items.length > 0 && total >= (this.options.config.cart_gift_min_price*100) && total != 0){
                    await this.addItem(this.options.config.cart_gift_product_vid, 1, "", "", false); 
                }
            }else{ 
                if(cart.items.length == 0 || total < (this.options.config.cart_gift_min_price*100) || total == 0){
                    await this.updateItem(this.options.config.cart_gift_product_vid, 0, line); 
                }else{
                    if(lineQty > 1){
                        await this.updateItem(this.options.config.cart_gift_product_vid, 1, line); 
                    }
                }
            }
        } 
    }
 

    buildItem(item, line){     
        var contentItem = this.createElementWithClass("div", "content-item");  
        contentItem.setAttribute("data-line", line);
        contentItem.setAttribute("data-qty", item.quantity);
        contentItem.setAttribute("data-id", item.id);
        contentItem.setAttribute("data-vid", item.variant_id);
        contentItem.setAttribute("data-sku", item.sku);
        contentItem.setAttribute("data-price", item.final_line_price); 
        contentItem.setAttribute("data-type", item.product_type); 
        var contentItemLeft = this.createElementWithClass("div", "content-item-left"); 
        var contentItemMid = this.createElementWithClass("div", "content-item-mid"); 
        var contentItemRight = this.createElementWithClass("div", "content-item-right"); 

        //Content Left
        var contentImage = this.createElementWithClass("a", "content-image");  
        contentImage.setAttribute("href", item.url);
        if(typeof item.featured_image != "undefined" && item.featured_image.url != "" && item.featured_image.url != null){  
            var urlImgSplit = item.featured_image.url.split("."); 
            var urlImg = urlImgSplit[0] + "." + urlImgSplit[1] + "." + urlImgSplit[2] + "_100x." + urlImgSplit[3];
            contentImage.innerHTML = `<img src="${urlImg}" alt="${item.title}" />`; 
        } 
 
        var descBundle = document.createElement("ul");
        descBundle.classList.add("desc-bundle"); 
        if(typeof catalog[item.variant_id] != "undefined" && catalog[item.variant_id].pack){
            contentItem.classList.add("bundle");  
            catalog[item.variant_id].pack_prds.forEach(prd => {   
                let liDesc = document.createElement("li");
                let leftLiDesc = document.createElement("div"); 
                leftLiDesc.classList.add("left"); 
                leftLiDesc.innerHTML = `<div class="qty">x${prd.qty}</div><img src="${catalogById[prd.id].img}">`;  
                let MidLiDesc = document.createElement("div");
                MidLiDesc.classList.add("mid");
                MidLiDesc.innerHTML = catalogById[prd.id].name;
                let RightLiDesc = document.createElement("div");
                RightLiDesc.classList.add("right"); 
                liDesc.appendChild(leftLiDesc);
                liDesc.appendChild(MidLiDesc);
                liDesc.appendChild(RightLiDesc);
                descBundle.appendChild(liDesc);
            });
        }

        //Content Mid
        var contentTitlePrd = this.createElementWithClass("div", "content-title");  
        contentTitlePrd.innerHTML = item.product_title; 
        if(typeof catalog[item.variant_id] != "undefined" && !catalog[item.variant_id].pack){
            var contentContenance = this.createElementWithClass("div", "content-contenance");
            var contenance = this.createElementWithClass("div", "contenance"); 
            var options = item.options_with_values; 
            var titleContenance = "";
            options.forEach(option => {
                if((option.name == "Couleur" || option.name == "couleur") && option.name != "" && option.value != ""){
                    if(option.value.indexOf("-") != -1){
                        titleContenance = option.value.split("-")[1];
                    }else{
                        titleContenance = option.value;  
                    }
                }
            }); 
            contenance.innerHTML = titleContenance;  
            contentContenance.appendChild(contenance);
        }

        //Qty
        var contentQty = this.createElementWithClass("div", "content-qty");
        var contentQtyMinus = this.createElementWithClass("div", "content-min"); 
        var contentQtyCurrent = this.createElementWithClass("div", "content-current"); 
        contentQtyCurrent.innerHTML = item.quantity;
        var contentQtyPlus = this.createElementWithClass("div", "content-plus"); 
        if(item.price != 0){
            contentQty.appendChild(contentQtyMinus); 
            contentQty.appendChild(contentQtyCurrent); 
            contentQty.appendChild(contentQtyPlus); 
        }  

        //Content Right
        var btnRemove = this.createElementWithClass("div", "btn-remove");
        btnRemove.innerHTML = `<div class="head"></div><div class="core"></div>`; 


        var contentPrice = this.createElementWithClass("div", "content-price"); 
        if(item.final_line_price != 0){
            var byunit = this.createElementWithClass("div", "unit"); 
            byunit.innerHTML = "/unité";
        }
        var oldprice = this.createElementWithClass("div", "oldprice"); 
        var price = this.createElementWithClass("div", "price"); 
         

        if(item.final_line_price == 0){
            price.innerHTML = this.options.config.cart_text_free;  
            price.classList.add("free");
        }else{    
            price.innerHTML = this.formatPrice(item.discounted_price, cart.currency);   
        }  

        if(typeof catalog[item.variant_id] != "undefined" && typeof catalog[item.variant_id].data_compare_at_price != "undefined" && parseInt(catalog[item.variant_id].data_compare_at_price) > parseInt(catalog[item.variant_id].data_price)){ 
            oldprice.innerHTML = this.formatPrice(catalog[item.variant_id].data_compare_at_price);
        }else{
            if(typeof catalog[item.variant_id] != "undefined" && typeof catalog[item.variant_id].data_price != "undefined" && parseInt(catalog[item.variant_id].data_price) > parseInt(item.discounted_price)){
                oldprice.innerHTML = this.formatPrice(catalog[item.variant_id].data_price);
            }else{
                oldprice.innerHTML = "";
            } 
        }
        if(item.final_line_price != 0){
            contentPrice.appendChild(byunit);
        }
        contentPrice.appendChild(oldprice);
        contentPrice.appendChild(price); 

        //buildLoader
        var contentLoader = this.createElementWithClass("div", "content-loader");
        var loader = this.createElementWithClass("div", "loader");
        var midLoader = this.createElementWithClass("div", "mid");
        loader.appendChild(midLoader);
        contentLoader.appendChild(loader); 
        contentPrice.appendChild(contentLoader);

        //Last build
        if(typeof catalog[item.variant_id] != "undefined" && !catalog[item.variant_id].pack){
            contentItemLeft.appendChild(contentImage);
        }


        contentItemMid.appendChild(contentTitlePrd);

        if(typeof catalog[item.variant_id] != "undefined" && !catalog[item.variant_id].pack){
        contentItemMid.appendChild(contentContenance); 
        }

        contentItemMid.appendChild(descBundle); 
        contentItemMid.appendChild(contentQty);
        
        if(item.final_line_price != 0){
            contentItemRight.appendChild(btnRemove);
        }
        contentItemRight.appendChild(contentPrice); 

        if(typeof catalog[item.variant_id] != "undefined" && !catalog[item.variant_id].pack){
        contentItem.appendChild(contentItemLeft);
        }

        contentItem.appendChild(contentItemMid);
        contentItem.appendChild(contentItemRight); 

        //Event +/-/delete
        if(item.final_line_price != 0){
            contentQtyPlus.addEventListener("click", () => {
                contentItem.classList.toggle("loading"); 
                var newQty = parseInt(contentItem.getAttribute("data-qty")) + 1;
                var line = parseInt(contentItem.getAttribute("data-line"));
                var callback = function(){
                    contentItem.classList.toggle("loading"); 
                };
                this.updateItem(item.variant_id, newQty, line, callback, contentItem.getAttribute("data-type"));
                if(typeof catalog[item.variant_id] != "undefined"){ 
                    let discount = 0;
                    if(catalog[item.variant_id].data_compare_at_price != "" && catalog[item.variant_id].data_compare_at_price != "0"){
                        if(parseInt(catalog[item.variant_id].data_price) < parseInt(catalog[item.variant_id].data_compare_at_price)){
                            discount = (parseInt(catalog[item.variant_id].data_compare_at_price) / 100) - (parseInt(catalog[item.variant_id].data_price) / 100);
                        }
                    } 
                    track.push({
                        "event" : "add_to_cart",  
                        value: parseInt(catalog[item.variant_id].data_price) / 100,
                        items: [
                            {
                                item_id: catalog[item.variant_id].id,
                                group_id: catalog[item.variant_id].group_id,
                                item_name: catalog[item.variant_id].name,
                                discount: discount, 
                                item_brand: catalog[item.variant_id].brand,
                                item_category: catalog[item.variant_id].category, 
                                price: parseInt(catalog[item.variant_id].data_price) / 100,
                                quantity: 1
                            }
                        ]
                    }); 
                }
            });

            contentQtyMinus.addEventListener("click", () => {
                contentItem.classList.toggle("loading");
                var newQty = parseInt(contentItem.getAttribute("data-qty")) - 1;
                var line = parseInt(contentItem.getAttribute("data-line"));
                var callback = () => {
                    contentItem.classList.toggle("loading");
                };
                this.updateItem(item.variant_id, newQty, line, callback, contentItem.getAttribute("data-type"));
                if(typeof catalog[item.variant_id] != "undefined"){ 
                    let discount = 0;
                    if(catalog[item.variant_id].data_compare_at_price != "" && catalog[item.variant_id].data_compare_at_price != "0"){
                        if(parseInt(catalog[item.variant_id].data_price) < parseInt(catalog[item.variant_id].data_compare_at_price)){
                            discount = (parseInt(catalog[item.variant_id].data_compare_at_price) / 100) - (parseInt(catalog[item.variant_id].data_price) / 100);
                        }
                    } 
                    track.push({
                        "event" : "remove_from_cart",  
                        value: parseInt(catalog[item.variant_id].data_price) / 100,
                        items: [
                            {
                                item_id: catalog[item.variant_id].id,
                                group_id: catalog[item.variant_id].group_id,
                                item_name: catalog[item.variant_id].name,
                                discount: discount, 
                                item_brand: catalog[item.variant_id].brand,
                                item_category: catalog[item.variant_id].category, 
                                price: parseInt(catalog[item.variant_id].data_price) / 100,
                                quantity: 1
                            }
                        ]
                    }); 
                }
            });

            btnRemove.addEventListener("click", () => {
                contentItem.classList.toggle("loading");  
                var line = parseInt(contentItem.getAttribute("data-line"));
                let qty = parseInt(contentItem.getAttribute("data-qty"));
                var callback = function(){
                    contentItem.classList.toggle("loading"); 
                };
                this.updateItem(item.variant_id, 0, line, callback, contentItem.getAttribute("data-type"));
                if(typeof catalog[item.variant_id] != "undefined"){ 
                    let discount = 0;
                    if(catalog[item.variant_id].data_compare_at_price != "" && catalog[item.variant_id].data_compare_at_price != "0"){
                        if(parseInt(catalog[item.variant_id].data_price) < parseInt(catalog[item.variant_id].data_compare_at_price)){
                            discount = (parseInt(catalog[item.variant_id].data_compare_at_price) / 100) - (parseInt(catalog[item.variant_id].data_price) / 100);
                        }
                    } 
                    track.push({
                        "event" : "remove_from_cart",  
                        value: parseInt(catalog[item.variant_id].data_price) / 100,
                        items: [
                            {
                                item_id: catalog[item.variant_id].id,
                                group_id: catalog[item.variant_id].group_id,
                                item_name: catalog[item.variant_id].name,
                                discount: discount, 
                                item_brand: catalog[item.variant_id].brand,
                                item_category: catalog[item.variant_id].category, 
                                price: parseInt(catalog[item.variant_id].data_price) / 100,
                                quantity: qty
                            }
                        ]
                    }); 
                }
            });  
        }

        if(item.properties != null && typeof item.properties.homme != "undefined" && item.properties.homme){
            contentItem.classList.add("homme");
        }

        return contentItem;
    }
 

    getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
 

    async buildCart(cart){   
        let cartCheck = await this.getCart(); 
        if(cart.total_price != cartCheck.total_price){
            cart = cartCheck;
        } 
        cart.items.forEach(item => {    
            this.contentItems.appendChild(this.buildItem(item, this.lineCount));
            this.lineCount += 1; 
        });
        this.majCountCart(cart.item_count);
        this.majPriceCart(cart);
        this.buildCompensateGift(cart.total_price, cart);   
    } 

    createElementWithClass(type, className){
        var element = document.createElement(type);
        element.classList.add(className);
        return element;
    }

    closeCart(){
        this.body.classList.toggle('cart-open'); 
        this.body.classList.toggle('freeze');
        document.querySelector("html").classList.toggle('freeze');  
    }

    openCart(){
        
            this.body.classList.toggle('cart-open'); 
            this.body.classList.toggle('freeze');
            document.querySelector("html").classList.toggle('freeze'); 

            let total = Number(this.btnCo.querySelector(".total").innerHTML.replace(/[^0-9.-]+/g,""));
            let items = [];

            this.contentItems.querySelectorAll(".content-item").forEach(item => { 
                let item_id = parseInt(item.getAttribute("data-vid"));
                let group_id = parseInt(item.getAttribute("data-id"));
                let item_name = catalog[item_id].name;
                let discount = catalog[item_id].data_compare_at_price != "" ? parseInt(catalog[item_id].data_compare_at_price) / 100 - parseInt(catalog[item_id].data_price / 100) : 0;
                let price = parseInt(catalog[item_id].data_price) / 100;
                let item_brand = catalog[item_id].brand;
                let item_category = catalog[item_id].category; 
                let quantity = 0
                if(item.querySelector(".content-qty .content-current") != null){
                    quantity = item.querySelector(".content-qty .content-current").innerHTML;
                }else{
                    quantity = 1; 
                } 
                items.push({
                    "item_name": item_name,
                    "group_id": group_id,
                    "item_id": item_id,
                    "discount" : discount,
                    "price": price,
                    "item_brand": item_brand,
                    "item_category": item_category, 
                    "quantity": quantity
                });
            });   
            if(items.length > 0){
                track.push({
                    event: "view_cart", 
                    value: total,  
                    items: items
                }); 
            } 
    }

    async majCart(cart){   
        await this.resetLine(cart);  
        await this.majCountCart(cart.item_count);
        await this.majPriceCart(cart);
        await this.majPriceItem(cart);
        await this.majProgressbarShipping(cart.total_price, this.palliersGifts, cart);   
        this.removeLoading(this.btnCo);
    }

    async majPriceItem(cart){
        cart.items.forEach(item => {   
            if(document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "']") != null){
                if(item.final_line_price != 0){
                    document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "'] .price").innerHTML = this.formatPrice(item.discounted_price);
                }
                if(typeof catalog[item.variant_id] != "undefined" && typeof catalog[item.variant_id].data_compare_at_price != "undefined" && parseInt(catalog[item.variant_id].data_compare_at_price) > parseInt(catalog[item.variant_id].data_price)){ 
                    document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "'] .oldprice").innerHTML = this.formatPrice(catalog[item.variant_id].data_compare_at_price);
                }else{
                    if(typeof catalog[item.variant_id] != "undefined" && typeof catalog[item.variant_id].data_price != "undefined" && parseInt(catalog[item.variant_id].data_price) > parseInt(item.discounted_price)){
                        document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "'] .oldprice").innerHTML = this.formatPrice(catalog[item.variant_id].data_price);
                    }else{
                        document.querySelector(".content-list-items .content-item[data-vid='" + item.variant_id + "'] .oldprice").innerHTML = "";
                    } 
                }
            }
        });
    }

    async getCart() {
        const result = await fetch("/cart.js", {method :"GET", credentials: 'same-origin'}); 
        const res = await result.json();  
        if(res.items.length > 0){
            //minicart.classList.remove("empty");
        }else{
            //minicart.classList.add("empty"); 
        }
        return res;
    }

    async clearCart() {
        const result = await fetch("/cart/clear.js", {method :"POST", credentials: 'same-origin'}); 
        const res = await result.json();  
        if(res.items.length > 0){
            //minicart.classList.remove("empty");
        }else{
            //minicart.classList.add("empty"); 
        }
        return res;
    }

    async setNoteCart(note) {
        const result = await fetch("/cart/update.json", {
            method: "POST",
            credentials: 'same-origin',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                note: note
            })
        }); 
        return result.json();
    }

    async deleteAttributeCart(attribute, callback) { 
        const result = await fetch("/cart/update.json", {
            method: "POST",
            credentials: 'same-origin',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: `{"attributes":{"${attribute}":""}}`
        }); 
        const reponse = await result.json(); 
        if(callback != "" && typeof callback == "function"){
            if(typeof reponse.attributes[attribute] == "undefined"){
                callback();
            }  
        } 
    }

    async setAttributeCart(obj, attribute, callback) { 
        var message = false;
        const result = await fetch("/cart/update.json", {
            method: "POST",
            credentials: 'same-origin',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                attributes: obj
            })
        }); 
        const reponse = await result.json();   
        if(callback != "" && typeof callback == "function"){ 
            if(typeof reponse.attributes[attribute] != "undefined"){
                message = true;
            }
            callback(message);  
        } 
    } 

    async checkCartId(id){  
        const cart = await this.getCart();   
        var obj = false;
        if(cart.items.length > 0){  
          cart.items.forEach(function(item, index){ 
            if(item.id == id){
              obj = {id:id, line:index, qty:item.quantity}; 
              if(item.properties != null && Object.keys(item.properties).length != 0){
                obj["properties"] = item.properties;
              }
              return obj;  
            }
          });
        }
        return obj;
    }

    async addItemArray(prds, props, btn, open) {  
        btn.classList.add("loading");
        let items_gtm = [];
        let value_gtm = 0;  
        for(let i = 0; i < prds.length; i++){
            var vid = prds[i]; 
            let config = {
                "id": vid, 
                "form_type": "product",
                "quantity": 1
            };  
            if(props != ""){
                config["properties"] = props; 
            }     
            let discount = 0;
            if(catalog[vid].data_compare_at_price != "" && catalog[vid].data_compare_at_price != "0"){
                if(parseInt(catalog[vid].data_price) < parseInt(catalog[vid].data_compare_at_price)){
                    discount = (parseInt(catalog[vid].data_compare_at_price) / 100) - (parseInt(catalog[vid].data_price) / 100);
                }
            }
            value_gtm += parseInt(catalog[vid].data_price) / 100;
            items_gtm.push({
                item_id: catalog[vid].id,
                group_id: catalog[vid].group_id,
                item_name: catalog[vid].name,
                discount: discount, 
                item_brand: catalog[vid].brand,
                item_category: catalog[vid].category, 
                price: parseInt(catalog[vid].data_price) / 100,
                quantity: 1
            });
            const checkCart = await this.checkCartId(vid);   
            if(checkCart == false){ 
                await this.addItem(vid, 1, "", "", false); 
            }else if(typeof checkCart == "object"){    
                var qtyUp = checkCart.qty + 1;
                await this.updateItem(checkCart.id, qtyUp, checkCart.line); 
            }  
        };     
 
        track.push({
            "event" : "add_to_cart",  
            value: value_gtm,
            items: items_gtm
        }); 
 
        if(open != false && window.innerWidth >= 992){
            this.openCart();
        }
        if(typeof btn != "undefined" && btn != ""){
            this.removeLoading(btn);
        } 
    }  
 
    async addItem(vid, qty, props, btn, open, callback) {  
        this.btnCo.classList.add("loading");
        let config = {
          "id": vid, 
          "form_type": "product",
          "quantity": qty
        };  
        if(props != ""){
          config["properties"] = props; 
        }     

        let discount = 0;
        if(catalog[vid] && catalog[vid].data_compare_at_price != "" && catalog[vid].data_compare_at_price != "0"){
            if(parseInt(catalog[vid].data_price) < parseInt(catalog[vid].data_compare_at_price)){
                discount = (parseInt(catalog[vid].data_compare_at_price) / 100) - (parseInt(catalog[vid].data_price) / 100);
            }
        } 
        if(catalog[vid]){
            track.push({
                "event" : "add_to_cart",  
                value: parseInt(catalog[vid].data_price) / 100,
                items: [
                    {
                        item_id: catalog[vid].id,
                        group_id: catalog[vid].group_id,
                        item_name: catalog[vid].name,
                        discount: discount, 
                        item_brand: catalog[vid].brand,
                        item_category: catalog[vid].category, 
                        price: parseInt(catalog[vid].data_price) / 100,
                        quantity: 1
                    }
                ]
            }); 
        }

        const checkCart = await this.checkCartId(vid);   
        if(checkCart == false){ 
            const result = await fetch("/cart/add.js", {
                method: "POST",
                credentials: 'same-origin',
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json"
                },
                body: JSON.stringify(config)
            });
            const res = await result.json();   
            this.lineCount += 1;
            this.contentItems.prepend(this.buildItem(res, this.lineCount)); 
            const cart = await this.getCart();   
            await this.majCart(cart);
        }else if(typeof checkCart == "object"){    
            var qtyUp = checkCart.qty + 1;
            await this.updateItem(checkCart.id, qtyUp, checkCart.line); 
        } 
        if(open != false && window.innerWidth >= 992){
            this.openCart();
        }
        if(typeof btn != "undefined" && btn != ""){
            this.removeLoading(btn);
        }
        if(callback != "" && typeof callback == "function"){
            callback();
        }
        if(typeof btn != "undefined" && btn != "" && btn.classList.contains("sample")){
            this.removeLoading(btn);
        } 
    }  

    async updateItem(vid, quantity, line, callback, product_type, majCart = true) {  
        this.btnCo.classList.add("loading");
        const result = await fetch("/cart/change.js", {
            method: "POST", 
            credentials: 'same-origin',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            //accept only string
            body: JSON.stringify({
              id : vid.toString(),
              quantity : quantity.toString()
            })
        });
        const res = await result.json(); 
        const cart = await this.getCart();     
        var itemUpdated = res.items[line];
        var itemsCount = cart.item_count;   
        if(quantity != 0){  
            if(callback != "" && typeof callback == "function"){
                this.updateItemFront(cart, itemUpdated, line, callback, majCart); 
            }else{
                this.updateItemFront(cart, itemUpdated, line, "", majCart); 
            }
        }else{  
            if(callback != "" && typeof callback == "function"){
                this.removeItemFront(cart, itemUpdated, line, callback, majCart); 
            }else{
                this.removeItemFront(cart, itemUpdated, line, "", majCart); 
            }   
            this.lineCount -= 1; 
        } 
    }
} 